/** Localised round / phase label (API stores English `round_label`). */

const STAGE_KEYS = {
  PO: "round.po",
  R32: "round.r32",
  R16: "round.r16",
  QF: "round.qf",
  SF: "round.sf",
  TPP: "round.tpp",
  FINAL: "round.final",
};

/**
 * @param {{ stage?: string, group?: string, round_label?: string }} m
 * @param {(key: string) => string} t
 */
export function matchRoundDisplay(m, t) {
  if (!m) return "—";
  if (m.stage === "GROUP" && m.group) {
    return `${t("flat.groupPrefix")} ${m.group}`;
  }
  const key = STAGE_KEYS[m.stage];
  if (key) return t(key);
  return m.round_label || "—";
}
